<button
  bit-chip-action
  type="button"
  [disabled]="disabled"
  appA11yTitle="{{ 'ownerBadgeA11yDescription' | i18n: name }}"
  routerLink
  [queryParams]="{ organizationId: organizationIdLink }"
  queryParamsHandling="merge"
  [label]="name | ellipsis: 13"
></button>
